import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_setting_card = _resolveComponent("setting-card")!

  return (_ctx.config)
    ? (_openBlock(), _createElementBlock("div", {
        key: _ctx.refreshKey,
        class: "w-full"
      }, [
        _createVNode(_component_setting_card, _mergeProps(_ctx.binds, {
          active: _ctx.config.mailCollect,
          "onUpdate:active": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.config.mailCollect) = $event)),
          dialogBind: _ctx.dialogBind,
          hideMoreVert: true,
          hidePrevious: true,
          onUpdateProfile: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateProfile()))
        }), {
          default: _withCtx(() => [
            (!_ctx.config.mailCollectKey)
              ? (_openBlock(), _createBlock(_component_v_row, {
                  key: 0,
                  "no-gutters": "",
                  class: "d-flex align-center justify-center pb-2",
                  style: {"min-width":"650px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "5",
                      class: "d-flex align-center justify-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          rounded: "",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.generateMailCollectKey())),
                          disabled: _ctx.config.mailCollectKey ? true : false
                        }, {
                          default: _withCtx(() => _cache[4] || (_cache[4] = [
                            _createTextVNode(" Générer un identifiant ")
                          ])),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "d-flex align-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field_filled, {
                            modelValue: _ctx.config.mailCollectKey,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.config.mailCollectKey) = $event)),
                            label: "Identifiant de collecte des mails",
                            outlined: "",
                            "hide-details": "",
                            readonly: "",
                            disabled: "",
                            density: "compact"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emailTemplates, (email, index) => {
                    return (_openBlock(), _createBlock(_component_v_row, {
                      key: index,
                      "no-gutters": "",
                      class: "d-flex align-center mt-4",
                      style: {"min-width":"850px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field_filled, {
                              outlined: "",
                              "hide-details": "",
                              readonly: "",
                              label: _ctx.getEmailLabel(email, index),
                              onClick: ($event: any) => (_ctx.copyToClipboard(email, index)),
                              "model-value": email,
                              density: "compact",
                              class: "pointer_text_field",
                              "append-inner-icon": _ctx.copied[index] ? '$fa-check' : '$fa-copy'
                            }, null, 8, ["label", "onClick", "model-value", "append-inner-icon"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ], 64))
          ]),
          _: 1
        }, 16, ["active", "dialogBind"])
      ]))
    : _createCommentVNode("", true)
}